<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="90px" class="mt35 PUB_flex_wrap">
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="平台">
              <el-select v-model="queryParams.platform_id" @change="search" placeholder="请选择平台" clearable class="w100">
                <el-option v-for="item in platformList" :key="item.id" :label="`${item.name}`"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="系统ID">
              <el-input v-model="queryParams.id" @change="search" placeholder="请输入系统ID" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="平台ID">
              <el-input v-model="queryParams.ks_id" @change="search" placeholder="请输入平台ID" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="是否有封面">
              <el-select v-model="queryParams.aicover" @change="search" placeholder="请选择是否有封面" clearable class="w100">
                <el-option label="有封面" value="1"></el-option>
                <el-option label="无封面" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="小说名称">
              <el-input v-model="queryParams.name" @change="search" placeholder="请输入小说名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="小说状态">
              <el-select v-model="queryParams.status" @change="search" placeholder="请选择小说状态" clearable class="w100">
                <el-option label="连载" value="0"></el-option>
                <el-option label="完结" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="频道">
              <el-select v-model="queryParams.gender_type" @change="search" placeholder="请选择频道" clearable class="w100">
                <el-option label="男生" value="1"></el-option>
                <el-option label="女生" value="2"></el-option>
                <el-option label="不限" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="审核状态">
              <el-select v-model="queryParams.sh_status" @change="search" placeholder="请选择审核状态" clearable class="w100">
                <el-option label="待审核" value="0"></el-option>
                <el-option label="审核中" value="1"></el-option>
                <el-option label="审核通过" value="2"></el-option>
                <el-option label="审核驳回" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="分类">
              <el-select v-model="queryParams.category_id" @change="updateCategory" placeholder="请选择分类" filterable
                clearable class="w100">
                <el-option v-for="(item, i) in categoryList" :key="item.id" :label="item.name"
                  :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="题材">
              <el-select v-model="queryParams.subject_id" @change="search" placeholder="请选择题材" filterable clearable
                class="w100">
                <el-option v-for="(item) in themeList" :key="(item.pcode || '') + '-' + item.id" :label="item.name"
                  :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="来源">
              <el-select v-model="queryParams.source" @change="search" placeholder="请选择小说来源" clearable class="w100">
                <el-option label="本地上传" value="1"></el-option>
                <el-option label="AI自动" value="2"></el-option>
                <el-option label="系统解析" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
              <el-form-item label="创建时间">
                <el-date-picker
                  v-model="queryParams.created_at"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="search"
                  style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
              <el-form-item label="提审时间">
                <el-date-picker
                  v-model="queryParams.ask_time"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="search"
                  style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
              <el-form-item label="快手审核">
                <el-date-picker
                  v-model="queryParams.sh_time"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="search"
                  style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button size="medium" @click="addNoNe">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="addNoNeList">刷新列表</el-button>
        <ExportButton
          :api-call="getApiExport()"
          :params="queryParams"
          :paramsProcessor="getQueryParams"
        />
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
      </div>
      <MyTable ref="myTableRef" :table-data="tableData" :columns="columns" :loading="loading" :total="total"
        :page-no="queryParams.pageNo" :page-size="queryParams.pageSize" @pagination-change="paginationChange">
        <!-- 封面 -->
        <template #full_cover="{ value }">
          <el-image v-if="value" style="width: 80px; height: 80px" :src="value" :preview-src-list="[value]" fit="cover">
          </el-image>
          <div v-else></div>
        </template>
        <!-- 作者 -->
        <template #author="{ value }">
          <div v-for="(item, index) in value" :key="index">{{ item }}</div>
        </template>
        <!-- 描述 -->
        <template #description="{ scope }">
          <el-tooltip placement="bottom">
            <div slot="content" class="maxw110" v-html="scope.row.description"></div>
            <span class="description-span">{{ scope.row.description }}</span>
          </el-tooltip>
        </template>
        <!-- 审核状态 -->
        <template #sh_status="{ scope, value }">
          <div style="margin-top: 6px;">
            <el-tag type="info" v-if="value == 0">{{ scope.row.sh_status_text }}</el-tag>
            <el-tag type="warning" v-else-if="value == 1">{{ scope.row.sh_status_text }}</el-tag>
            <el-tag type="success" v-else-if="value == 2">{{ scope.row.sh_status_text }}</el-tag>
            <template v-else-if="value == 3">
              <el-tooltip v-if="scope.row.audit_reason || scope.row.content_reason || scope.row.cover_reason"
                placement="bottom">
                <div slot="content" class="maxw110">
                  <div>书籍原因：{{ scope.row.audit_reason || '-' }}</div>
                  <div>内容原因：{{ scope.row.content_reason || '-' }}</div>
                  <div>封面原因：{{ scope.row.cover_reason || '-' }}</div>
                </div>
                <el-tag type="danger"><i class="el-icon-warning-outline"></i>{{ scope.row.sh_status_text }}</el-tag>
              </el-tooltip>
              <el-tag v-else type="danger">{{ scope.row.sh_status_text }}</el-tag>
            </template>
          </div>
        </template>
        <!-- 小说状态 -->
        <template #status="{ scope }">
          <span v-if="scope.row.status == 0">连载</span>
          <span v-if="scope.row.status == 1">完结</span>
        </template>
        <!-- 章节总数 -->
        <template #chapter_total="{ scope }">
          {{ scope.row.chapter_total }}章
        </template>
        <!-- 免费章节 -->
        <template #free_chapter_total="{ scope }">
          {{ scope.row.free_chapter_total }}章
        </template>
        <!-- 剩余全文折扣 -->
        <template #remaining_discount="{ value }">
          {{ value ? value + '%' : '' }}
        </template>
        <template #discount_pkg_list="{ value }">
          <template v-if="value.length > 0">
            <div class="discount_pkg_box" v-for="(item, i) in value" :key="i">
              <div>打包章节数量：{{ item.chapterCount }}章</div>
              <div>营销价格：{{ item.price }}元</div>
            </div>
          </template>
          <div v-else></div>
        </template>
        <!-- 自定义标签 -->
        <template #tags="{ value }">
          <template v-if="value.length > 0">
            <div style="margin-bottom: 2px;" v-for="(item, i) in value" :key="i"><el-tag size="small ">{{ item
                }}</el-tag></div>
          </template>
          <div v-else></div>
        </template>
        <template #operation>
          <el-table-column fixed="right" label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="medium" @click="addEdit(scope.row)">编辑</el-button>
              <el-button class="PUB_BTN_GREEN" type="text" size="medium" @click="handleToChatper(scope.row)">章节列表({{
                scope.row.real_chapter_total }})</el-button>
              <el-button
                :disabled="!((scope.row.sh_status != 1) && scope.row.chapter_total == scope.row.real_chapter_total)"
                type="text" size="medium" @click="handlePush(scope.row)">提审</el-button>
                <el-button type="text" size="medium" @click="handleDownload(scope.row)">下载</el-button>
              <el-button class="PUB_BTN_RED" type="text" size="medium" @click="addDel(scope.row)">删除</el-button>
              <el-button class="PUB_BTN_RED" type="text" size="medium" @click="addAi(scope.row)">生成AI封面</el-button>
            </template>
          </el-table-column>
        </template>
      </MyTable>
      <edit v-if="AddWorksFlag" :AddWorksFlag="AddWorksFlag" @NoneDlog="NoneDlog" @AddOk="AddOk" :editID="editID">
      </edit>
    </el-card>
  </div>
</template>

<script>
import { KsNovalManagement } from "@/api/ksNovalManagement";
import { processErrors } from "@/utils/errorHandler";
import Edit from "./component/novalEdit.vue"
import ExportButton from "@/components/ExportPart/ExportButton";
import { Session } from "@/utils/storage";
const api = KsNovalManagement();
export default {
  components: {
    Edit,
    ExportButton,
  },
  data() {
    return {
      columns: [
        {
          label: '系统ID',
          prop: 'id',
          width: '80',
          fixed: true,
        },
        {
          label: '平台ID',
          prop: 'ks_id',
          width: '130',
          fixed: true,
        },
        {
          label: '平台名称',
          prop: 'platform_text',
          width: '120',
          fixed: true,
        },
        {
          label: '封面',
          prop: 'full_cover',
          slotKey: 'full_cover',
          width: '120',
          fixed: true,
        },
        {
          label: '小说名称',
          prop: 'name',
          width: '140',
          fixed: true,
        },
        {
          label: '作者',
          prop: 'author',
          width: '130',
          slotKey: 'author',
        },
        {
          label: '来源',
          prop: 'source_text',
          width: '100',
          slotKey: 'source_text',
        },
        {
          label: '简介',
          prop: 'description',
          slotKey: 'description',
          width: '150',
        },
        {
          label: '审核状态',
          prop: 'sh_status',
          slotKey: 'sh_status',
          width: '120',
        },
        {
          label: '频道',
          prop: 'gender_type_text',
          width: '100',
        },
        {
          label: '分类',
          prop: 'category_text',
          width: '100',
        },
        {
          label: '题材',
          prop: 'subject_text',
          width: '100',
        },
        {
          label: '自定义标签',
          prop: 'tags',
          slotKey: 'tags',
          width: '120',
        },
        {
          label: '小说状态',
          prop: 'status',
          slotKey: 'status',
          width: '100',
        },
        {
          label: '小说总字数',
          prop: 'word_cnt',
          slotKey: 'word_cnt',
          width: '140',
        },
        {
          label: '章节总数',
          prop: 'chapter_total',
          slotKey: 'chapter_total',
        },
        {
          label: '收费类型',
          prop: 'sales_type_text',
          width: '100',
        },
        {
          label: '免费章节数',
          prop: 'free_chapter_total',
          slotKey: 'free_chapter_total',
          width: '120',
        },
        {
          label: '单章价格',
          prop: 'chapter_price',
          slotKey: 'chapter_price',
          width: '100',
        },
        {
          label: '剩余全文付费折扣',
          prop: 'remaining_discount',
          slotKey: 'remaining_discount',
          width: '150',
        },
        {
          label: '多章优惠包',
          prop: 'discount_pkg_list',
          slotKey: 'discount_pkg_list',
          width: '170',
        },
        {
          label: '全文价格',
          prop: 'total_price',
          slotKey: 'total_price',
        },
        {
          label: '全文价格（原价）',
          prop: 'total_origin_price',
          slotKey: 'total_origin_price',
          width: '150',
        },
        {
          label: '创建时间',
          prop: 'created_at',
          width: '170',
        },
        {
          label: '更新时间',
          prop: 'updated_at',
          width: '170',
        },
        {
          label: '提审时间',
          prop: 'ask_time',
          width: '170',
        },
        {
          label: '快手审核时间',
          prop: 'sh_time',
          width: '170',
        },
      ],
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        platform_id: "",
        id: "",
        name: "",
        status: "",
        source: "",
        gender_type: "",
        sh_status: "",
        category_id: "",
        subject_id: "",
        ks_id: "",
        created_at: [],
        ask_time: [],
        sh_time: [],
        aicover: '',
      },

      categoryList: [],
      themeList: [],


      appidList: [],
      page: {
        pageNo: 1,
        pageSize: 999,
        type: "4"
      },
      tableData: [],
      editID: "",
      // 总条数
      total: 0,
      SearchFlag: false,
      AddWorksFlag: false,
      dialogTableVisible: false,
      videoObj: "",
      loading: false,
      addFrom: {},
      informationFlag: false,
      InfoeditID: false,
      platformList: [],
      AiFlag: false
    };
  },
  created() {
    if (this.$route.query.isback && Session.get("pQuery")) {
      this.queryParams = JSON.parse(Session.get("pQuery"))
      this.getList('changePage')
    } else {
      this.getList()
    }
    this.getCategoryList()
    this.getThemeList()
    this.getPlatformList()
  },
  methods: {
    getApiExport() {
      return api.Apiexport;
    },
    getQueryParams(){
      let query = {...this.queryParams}

      // 处理创建时间传参
      if(query.created_at && Array.isArray(query.created_at)){
        query.created_at = query.created_at.join(',')
      }

      // 处理提审时间传参
      if(query.ask_time && Array.isArray(query.ask_time)){
        query.ask_time = query.ask_time.join(',')
      }

      // 处理提审时间传参
      if(query.sh_time && Array.isArray(query.sh_time)){
        query.sh_time = query.sh_time.join(',')
      }

      return query
    },
    objectToQueryString(obj) {
      const params = new URLSearchParams();
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          params.append(key, obj[key]);
        }
      }
      return params.toString();
    },
    addAi(row) {
      this.$confirm('是否生成Ai封面 ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {


          api.ApiAicover(row.id).then(res => {
            if (res.code == 0) {
              this.$message({
                message: '生成Ai封面成功',
                type: 'success'
              });
              this.getList('changePage')
            } else {
              processErrors(res);
            }
          });
        })
        .catch(() => {

        });
    },
    getPlatformList() {
      api.ApiPlatformList({ pageNo: 1, pageSize: 999, }).then(res => {
        if (res.code == 0) {
          this.platformList = res.data.data
        } else {
          processErrors(res);
        }
      })
    },
    getCategoryList() {
      api.ApiCategorySelect().then(res => {
        if (res.code == 0) {
          this.categoryList = res.data
        } else {
          processErrors(res);
        }
      })
    },
    getThemeList(pcode) {
      api.ApiCategoryThemesSelect({ pcode: pcode ? pcode : "" }).then(res => {
        if (res.code == 0) {
          this.themeList = res.data
        } else {
          processErrors(res);
        }
      })
    },
    updateCategory() {
      // this.queryParams.subject_id = ""
      // this.getThemeList(this.queryParams.category_id)
      this.search()
    },
    getList(type) {
      this.loading = true;
      this.tableData = []
      if (type != 'changePage') {
        this.queryParams.pageNo = 1
      }
      api.ApiNovelList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false;
      })
    },
    // 打开搜索
    addSearch() {
      if (this.SearchFlag == false) {
        this.SearchFlag = true
      } else {
        this.SearchFlag = false
      }
    },
    // 搜索
    search() {
      this.queryParams.pageNo = 1
      this.getList()
    },
    paginationChange({ pageNo, pageSize }) {
      this.queryParams.pageNo = pageNo
      this.queryParams.pageSize = pageSize
      this.getList('changePage')
    },
    // 重置列表
    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        platform_id: "",
        id: "",
        name: "",
        status: "",
        soure: "",
        gender_type: "",
        sh_status: "",
        category_id: "",
        subject_id: "",
        ks_id: "",
        created_at: [],
        ask_time: [],
        sh_time: [],
        aicover: '',
      }
      this.getList()
    },
    addNoNeList() {
      this.getList()
    },
    handleToChatper(item) {
      Session.set('pQuery', JSON.stringify(this.queryParams))
      this.$router.push({
        path: '/ksNovalManagement/novalManagement/chapters',
        query: {
          nid: item.id,
          name: item.name,
          salesType: item.sales_type,
          freeChapterTotal: item.free_chapter_total,
        }
      })
    },
    addList() {
      this.editID = ""
      this.AddWorksFlag = true
    },
    NoneDlog() {
      this.AddWorksFlag = false
    },
    AddOk() {
      this.editID = ""
      this.AddWorksFlag = false
      this.getList('changePage')
    },

    addEdit(row) {
      this.editID = row.id
      this.AddWorksFlag = true
    },

    handlePush(item) {
      this.$confirm('确定提审吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.ApiNovelSubmit({ id: item.id }).then(res => {
          if (res.code == 0) {
            this.$message.success('提审成功')
            this.getList('changePage');
          } else {
            processErrors(res);
          }
        })
      }).catch(() => {
        // 取消 
      });

    },

    addDel(row) {
      this.$confirm('确定删除该作品吗 ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          api.ApiNovelDel({ id: row.id }).then(res => { // 假设 DelList 接受一个 id，而不是数组
            if (res.code == 0) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.getList('changePage')
            } else {
              processErrors(res);
            }
          });
        })
        .catch(() => {

        });
    },
    handleDownload(row) {
      this.$confirm(`确定下载小说《${row.name}》吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let params = {
            id: row.id,
          }
          params.token = Session.get('token')
          // 获取基础 URL
          const baseExportUrl = process.env.VUE_APP_BASE_API + '/admin/ksnovel/novel/generatetxt';
          // 拼接 URL 参数
          window.location.href = baseExportUrl + '?' + this.objectToQueryString(params)
      }).catch(() => {
        // 取消操作
      });
    },


  },

}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep el-card__body {

    padding: 0 !important;

  }

  .custom-input ::v-deep .el-input__inner {
    text-align: center;
  }
}

.description-span {
  display: -webkit-box;
  /* 对于 Webkit 浏览器的兼容性 */
  -webkit-line-clamp: 3;
  /* 显示的行数 */
  -webkit-box-orient: vertical;
  /* 设置或检索伸缩盒对象的子元素的排列方式 */
  overflow: hidden;
  text-overflow: ellipsis;
  //white-space: nowrap;
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.maxw110 {
  max-width: 110px;
}

.discount_pkg_box {
  font-size: 12px;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }
}
</style>